import { Breakpoint, Button, Dialog, DialogActions, DialogContent, DialogTitle, Theme } from '@mui/material';
import React from "react";
import { makeStyles } from '@mui/styles';
import useLocales from '../../hooks/useLocales';

export interface DialogProps {
    open: boolean;
    onClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onSave: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    title: string;
    children: any;
    actionButtonsDisabled?: boolean;
    size: Breakpoint;
    componentName? : string
}

const useStyles = makeStyles((theme: Theme) => ({
    dialogTitle: {
        color: 'white',
        backgroundColor: '#90AEC8',
        textAlign: 'center',
    },
    dialogFooter: {
        backgroundColor: '#D6DADC',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    containedButton: {
        width: '100px',
        // backgroundColor: '#90AEC8',
    },
    outlinedButton: {
        width: '100px',
        backgroundColor: 'white'
    }
}));

export default function DialogBaseV2(props: DialogProps) {
    const { onClose, onSave, open, title, children, actionButtonsDisabled, size,componentName, ...other } = props;
    const { translate } = useLocales();
    const classes = useStyles();

    return (
        <Dialog
            disableEscapeKeyDown
            fullWidth
            maxWidth={size}
            aria-labelledby="confirmation-dialog-title"
            open={open}
            {...other}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions color='primary'>
                <Button onClick={onClose} variant="outlined" className={classes.outlinedButton} >{translate('Common.' + "Cancel")}</Button>
                <Button  data-component={componentName + ': Save'}  disabled={actionButtonsDisabled} onClick={onSave} variant="contained" className={classes.containedButton} color='primary' >{translate('Common.' + "Save")}</Button>
            </DialogActions>
        </Dialog>
    );
}